import React from "react";
import styled from "styled-components";
import AgeCheckerLogo from "src/integrations/identityVerification/ageChecker/AgeCheckerLogo";

export default function AgeCheckerPoweredBy() {
  return (
    <Container>
      <span>Verification powered by</span>
      <AgeCheckerLogo />
    </Container>
  );
}

const Container = styled.div`
  padding-top: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;

  > span {
    font-size: 12px;
    color: #888888;
  }
`;
